import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';

import {
  TablePagination,
  Box,
  TableRow,
  TableCell,
  Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';

import TableListHead from '../../layouts/TableListHead';
// import { format } from 'date-fns';

import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';

const fetchOrder = async (params) => {
  const { limit, page, sort, order } = params;
  const res = await axios.get(API_URL + '/dashboard/team/goacb', {
    params: { limit, page, sort, order, partnerId: '651ad6f1c1a65100147fbf80' },
  });

  return res;
};

function Index() {
  const [paginationData, setPaginationData] = useState({
    page: 0,
    limit: 50,
    sort: 'firstName',
    order: 'asc',
  });

  const { status, data, isFetching } = useQuery(
    [`fetchGoaUser`, paginationData],
    () => fetchOrder({ ...paginationData }),
    { keepPreviousData: true }
  );

  const handleRequestSort = (event, property) => {
    const isAsc =
      paginationData.sort === property && paginationData.order === 'asc';
    setPaginationData({
      ...paginationData,
      sort: property,
      order: isAsc ? 'desc' : 'asc',
    });
  };

  const TABLE_HEAD = [
    { id: 'firstName', label: 'Name', align: 'left' },
    { id: 'email', label: 'Email', align: 'left' },
    { id: 'university', label: 'University', align: 'left' },
    { id: 'course', label: 'Course', align: 'left' },
    { id: 'aptitudeTest.percentage', label: 'Aptitude Test', align: 'left' },
  ];

  const handleChangePage = (event, newPage) => {
    setPaginationData({
      ...paginationData,
      page: newPage,
    });
  };
  const handleChangeRowsPerPage = (event) => {
    setPaginationData({
      ...paginationData,
      page: 0,
      limit: event.target.value,
    });
  };

  return (
    <>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
          minWidth='100vw'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <>
          <Typography m={2}>Goa Career Bootcamp </Typography>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650, shadow: 2, padding: '6px' }}
              aria-label='table'
              size='small'
            >
              <TableListHead
                order={paginationData.order}
                orderBy={paginationData.sort}
                headLabel={TABLE_HEAD}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {data.data.data.map((row) => (
                  <TableRow
                    key={row._id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align='left'>
                      {row.firstName} {row.lastName}{' '}
                    </TableCell>
                    <TableCell align='left'> {row.email} </TableCell>

                    <TableCell align='left'>{row.university} </TableCell>
                    <TableCell align='left'>{row.course} </TableCell>
                    <TableCell align='left'>
                      {' '}
                      {row.aptitudeTest?.percentage}{' '}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[
                ...new Set([paginationData.limit, 50, 100, 500]),
              ]}
              component='div'
              count={data.data.totalCount}
              rowsPerPage={paginationData.limit}
              page={paginationData.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              nextIconButtonProps={{
                disabled:
                  isFetching || data.data.page === data.data.totalPages - 1,
              }}
            />
          </TableContainer>
        </>
      )}
    </>
  );
}

export default Index;
